<template lang="pug">
.content-wrap
  #ambassadorModal1.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered
      .modal-content
        .position-absolute.close-button.pointer.c-style.mt-2.me-2(@click="$helpers.closeModal('#ambassadorModal1')")
          i.fa-solid.fa-x.fa-2x
        .modal-header-cus
          h2 Jake Cuenca Joins EpicWin Malaysia as Ambassador!
        .modal-iframe
          iframe(src='https://www.youtube.com/embed/8voPrRjuYLM?autoplay=1&mute=1&loop=1' allow="autoplay; encrypted-media")
  #ambassadorModal2.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered
      .modal-content
        .position-absolute.close-button.pointer.c-style.mt-2.me-2(@click="$helpers.closeModal('#ambassadorModal2')")
          i.fa-solid.fa-x.fa-2x
        .modal-header-cus
          h2 Exploring Popular Games in the Malaysia with Jake Cuenca, EpicWin Ambassador!
        .modal-iframe
          iframe(src='https://www.youtube.com/embed/pHB3od3vomI?autoplay=1&mute=1&loop=1' allow="autoplay; encrypted-media")
  #ambassadorModal3.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered
      .modal-content
        .position-absolute.close-button.pointer.c-style.mt-2.me-2(@click="$helpers.closeModal('#ambassadorModal3')")
          i.fa-solid.fa-x.fa-2x
        .modal-header-cus
          h2 Jake Cuenca Explores EpicWin Animal Farm: 7777x Jackpot Potential!
        .modal-iframe
          iframe(src='https://www.youtube.com/embed/BXnn4kxF4zo?autoplay=1&mute=1&loop=1' allow="autoplay; encrypted-media")
  //- buttonArea.d-none.d-md-flex(v-if="!isLoggedIn")
  .content-top
    .con
      .conbox
        .ambassador-wrapper
          .ambassbox
            .top
              .amb-pic
                img(src='/new/img/ambassador/ambassador.png')
              .amb-intro
                img(src='/new/img/ambassador/name.png')
            .ccon
              //
                <div class="framebox">
                <div class="bbg"><img src="/new/img/ambassador/video.png" /></div>
                <div class="frame">
                <iframe src="https://www.youtube.com/embed/9mCMd_j_G3I?si=_XNv1zQwp1jv8VmX">
                </div>
                </div>
              .frames
                a.btn-login(href='javascript:void(0)' @click="$helpers.openModal('#ambassadorModal1')")
                  img(src='/new/img/ambassador/contract.png')
                a.btn-login(href='javascript:void(0)' @click="$helpers.openModal('#ambassadorModal2')")
                  img(src='/new/img/ambassador/epicxall.png')
                a.btn-login(href='javascript:void(0)' @click="$helpers.openModal('#ambassadorModal3')")
                  img(src='/new/img/ambassador/animal.png')
  .footer-wrap
    .con
      .seo-wrap
        h1 Epic Malaysia Hire brand ambassador Named “ Jake Cuenca”
        h2 Introduction to Epic Malaysia:
        h5 Brief Overview:
        p Amazing Malaysia remains at the bleeding edge of industry, spearheading inventive arrangements and setting industry benchmarks since its origin. Laid out with a dream to change computerized scenes, drive innovative progressions, and so forth, Incredible Malaysia has reliably conveyed state of the art items and administrations custom-made to meet the developing requirements of its clients.
          br
          br
          | Driven by a guarantee to basic beliefs or standards, e.g., greatness, development, consumer loyalty, Legendary Malaysia has laid down a good foundation for itself as a confided in accomplice in the sector known for its dependability and groundbreaking approach. With a different portfolio the organization keeps on showing others how its done, forming the fate of industry through development and vital organizations.
        h5 Key Products or Services Offered:
        p
          | 1. Broadcast communications Arrangements: Awe-inspiring Malaysia gives progressed media communications arrangements, including high velocity internet providers, portable network arrangements, and customized media communications foundation for organizations.
          br
          br
          | 2. Endeavor Programming Arrangements: Awe-inspiring Malaysia offers hearty undertaking programming arrangements customized to smooth out activities, upgrade efficiency, and improve business processes across different enterprises.
          br
          br
          | 3. Computerized Advertising Administrations: Awe-inspiring Malaysia has some expertise in exhaustive advanced showcasing administrations, including Website optimization, SEM, web-based entertainment promoting, and content promoting systems intended to help online presence and drive client commitment.
        #readMore.d-inline(v-if="showMore")
          h2 Biography on Jake Cuenca
          h5 Jake Cuenca Age: He was brought into the world on December 30, 1987, and that too in San Jose, California, USA. Beginning around 2024, he is currently 36 years old.
          h5 Jake Cuenca Height : He remains at roughly 5 feet 10 inches (178 cm).
          h5 Professional Life:
          p Jake Cuenca is a Filipino-American performer and model who began his employment in news sources right off the bat. He gained appreciation in the Malaysia for his capacity and adaptability in acting. A piece of his conspicuous television sensations consolidate "Kung Tayo'y Magkakalayo," "Palos," and "Maria Mercedes." He has similarly appeared in changed motion pictures, showing his scope as a performer.
          h5 Personal Life
          p Jake Cuenca's own life frequently gathers media attention because of his connections and generous undertakings. He stays dynamic in the two his expert profession and special goals, offsetting his acting responsibilities with his inclinations beyond diversion.
          h5 Achievements and Awards
          p All through his profession, Jake Cuenca has gotten assignments and grants for his exhibitions in acting. His devotion to his specialty and flexibility have made him a regarded figure in Philippine showbiz.
          h2 Announcement of the Partnership:
          p
            | Legendary Malaysia is excited to declare its essential organization with Jake Cuenca, a praised entertainer eminent for his flexibility and charm in media outlets. This cooperation denotes a critical achievement for both Legendary Malaysia and Jake Cuenca, as they combine efforts to improve and raise brand commitment
            br
            br
            | Jake Cuenca's standing as a pioneer adjusts flawlessly with Epic Malaysia' obligation to his guiding principle or mission, e.g., development, consumer loyalty, and so on. Together, they expect to make convincing stories and noteworthy encounters that reverberate with crowds.
            br
            br
            | Jake Cuenca added, "I'm respected for collaborating with Epic Malaysia, an organization known for pushing limits and conveying extraordinary quality. Together, we anticipate motivating additional opportunities and having a significant effect.
          h2 Reason for Choosing Jake Cuenca:
          p - Incredible skill and Devotion: Jake Cuenca is known for his amazing skill and commitment to his art, reflecting Awe-inspiring Malaysia' obligation to greatness.
            br
            | - Flexibility and Versatility: His capacity to depict different jobs mirrors Epic Malaysia' way to deal with advancement and flexibility in the business.
            br
            | - Charm and Impact: Jake Cuenca's allure and impact reverberate with the characteristics that Amazing Malaysia tries to epitomize in its image personality.
          h5 Examples of Jake Cuenca’s Previous Endorsements and Their Success:
          p
            | 1. Bench: Jake Cuenca has been a noticeable endorser for Seat, a main Philippine dress brand. His support with Seat have assisted with reinforcing the brand's allure among the adolescent and style cognizant purchasers. His missions frequently feature Seat's popular and snazzy attire lines, adding to expanded brand perceivability and deals.
            br
            br
            | 2. Century Tuna: Jake Cuenca has likewise banded together with Century Fish, a famous brand known for its canned fish items. His supporters have really advanced Century Fish's wellbeing and wellness drives, resounding with wellbeing cognizant customers and building up the brand's status as a supplier of nutritious food choices.
          h2 Expectations and Goals:
          p - Upgrade Brand Perceivability: Influence Jake Cuenca's fame and impact to increment brand mindfulness among target socioeconomics.
            br
            | - Fortify Brand Picture: Partner Epic Malaysia with Jake Cuenca's positive credits like amazing skill, adaptability, and allure.
            br
            | - Drive Commitment: Make drawings in promoting efforts that reverberate with customers and support collaboration with the brand.
          h5 Anticipated Effect on Brand Mindfulness and Deals:
          p - Brand Mindfulness: The organization is supposed to essentially support Epic Malaysia' perceivability on the lookout, contacting a more extensive crowd through Jake Cuenca's broad fan base and media presence.
            br
            | - Deals Development: By improving brand discernment and commitment, Incredible Malaysia expects a positive effect on deals, as customers are bound to trust and pick items supported by Jake Cuenca.
          h5 Long haul Objectives of the Association:
          p - Economical Development: Cultivate a drawn out relationship that upholds Epic Malaysia' development targets across its product offerings.
            br
            | - Creative Missions: Ceaselessly foster innovative methodologies that gain by Jake Cuenca's allure and adjust to developing shopper patterns.
            br
            | - Local area Commitment: Use the organization to draw in with networks and backing social drives that line up with both Amazing Malaysia' and Jake Cuenca's qualities.
            br
            br
            | By setting clear expectations and goals, Epic Malaysia aims to maximize the benefits of the partnership with Jake Cuenca, ensuring mutual success and long-term impact in the market.
          h2 Public and Fan Reactions:
          p - Energy and Support: Devotees of Jake Cuenca and adherents of Epic Malaysia have communicated fervor about the cooperation, sharing their expectation for impending activities and missions.
            br
            | - Positive Feedback: Remarks via virtual entertainment feature the conviction that Jake Cuenca's appeal and impact will actually supplement Epic Malaysia' image personality and upgrade its market presence.
          h2 Future Collaborations:
          p - Publicizing Efforts: Jake Cuenca could highlight noticeably in impending promoting lobbies for new items or administrations sent off by Legendary Malaysia.
            br
            | - Advanced Content: Cooperation on computerized content like web series, video blogs, or in the background recordings that grandstand both Jake Cuenca's character and Amazing Malaysia' image values.
            br
            | - Occasion Appearances: Joint appearances at industry occasions, item dispatches, or special exercises to draw in with fans and partners.
          h5 Conclusion:
          p All in all, the organization between Legendary Malaysia and Jake Cuenca addresses an essential collusion pointed toward utilizing Jake Cuenca's impact and appeal to upgrade brand perceivability and commitment. Central issues examined include:
            p
              p - Key Arrangement: Jake Cuenca's picture resounds firmly with Epic Malaysia' upsides of amazing skill, development, and customer commitment.
                br
                | - Anticipated Effect: The coordinated effort is supposed to support brand mindfulness, drive deals, and reinforce Epic Malaysia' market position.
                br
                | - Future Possibilities: Open doors for future ventures and coordinated efforts are promising, including new missions and advanced content drives.
              p Join us in following this exciting journey! Stay tuned for updates on upcoming campaigns, exclusive content featuring Jake Cuenca, and insights into how Epic Malaysia continues to innovate and meet the needs of its audience. Your support and engagement are vital as we embark on this dynamic partnership.
              h5 FAQs
              p 1. For what reason did Epic Malaysia pick Jake Cuenca as their accomplice?
                br
                | - Legendary Malaysia picked Jake Cuenca because of his solid arrangement with their image of impressive skill, development, and appeal to an expansive segment. His impact in media outlets and positive public picture make him an optimal representative for the brand.
              p 2. What are the generally anticipated advantages of this organization?
                br
                | - The organization intends to improve brand perceivability, increment customer commitment, and drive deals development for Epic Malaysia. By utilizing Jake Cuenca's ubiquity and validity, the brand hopes to contact a more extensive crowd and reinforce its market position.
              p 3. What sort of undertakings or missions could we at any point anticipate from this cooperation?
                br
                | - Fans can expect different ventures and missions, including publicizing efforts, advanced content joint efforts, and potentially joint appearances at occasions. These drives will feature Jake Cuenca's inclusion with Epic Malaysia and feature their common obligation to quality and advancement.
              p 4. How might I remain refreshed on the most recent news and advancements connected with this organization?
                br
                | - You can follow Epic Malaysia on their authority web-based entertainment channels and site for declarations, in the background updates, and select substance highlighting Jake Cuenca. Drawing in with these stages will keep you informed about forthcoming efforts and occasions.
              // 
      button#moreBtn.btn-submit(@click="toggleC(1)" v-if="!showMore") + Read More
      button#moreBtn.btn-submit(@click="toggleC(0)" v-if="showMore") - Read Less

</template>
<script>
// import buttonArea from "@/component/_buttonArea.vue"
export default {
  components:{
    // buttonArea
  },
  data(){
    return{
      showMore: false
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
  },
  created(){
    $('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/ambassador`);
  },
  methods:{
    toggleC(option){
      if(option == 0){
        this.showMore = false
      }else{
        this.showMore = true
      }
    }
  }
}
</script>